module.exports = __webpack_public_path__ + "img/horizontal_6_4_pp1_8017.9c9eee64.png";